import { cn } from "../ui/utils";
import { OPTIVO_WORDMARK } from "./optivoWordmarkGeometry";

interface OptivoWordmarkProps {
    /** Sizing and colour for the whole logo, which follows `currentColor`. Defaults to the height of the text around it. */
    className?: string;
    /** Hide it from assistive technology where a label beside it already says "Optivo". */
    decorative?: boolean;
}

/**
 * The Optivo logo: "optivo" in Plus Jakarta Sans, outlined, the right stroke of
 * its "v" an arrow that rises past the other letters. One shape in one colour,
 * the text's own, so it is right in every skin and both modes. Drawn from a
 * path rather than set in the font, so it is the same logo before the web font
 * loads. The geometry is generated by tools/brand/build-logo.py, which also
 * writes brand/logo/.
 */
export function OptivoWordmark({ className, decorative = false }: OptivoWordmarkProps) {
    const { viewBox, path } = OPTIVO_WORDMARK;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox}
            className={cn("inline-block size-auto h-[1em] w-auto shrink-0", className)}
            {...(decorative ? { "aria-hidden": true } : { role: "img", "aria-label": "Optivo" })}
            focusable="false"
        >
            <path fill="currentColor" d={path} />
        </svg>
    );
}
